import { useCallback, useEffect, useState } from 'react';

import { CURRENT_POLICY_VERSION } from '../lib/policy';

interface PolicyAcceptanceRecord {
  version: string;
  acceptedAt: string;
}

const storageKey = (affiliateId: string) => `policy_acceptance_${affiliateId}`;

const readRecord = (affiliateId: string): PolicyAcceptanceRecord | null => {
  try {
    const raw = window.localStorage.getItem(storageKey(affiliateId));
    if (!raw) return null;
    return JSON.parse(raw) as PolicyAcceptanceRecord;
  } catch {
    return null;
  }
};

export const usePolicyAcceptance = (affiliateId?: string) => {
  const [record, setRecord] = useState<PolicyAcceptanceRecord | null>(null);

  useEffect(() => {
    setRecord(affiliateId ? readRecord(affiliateId) : null);
  }, [affiliateId]);

  const hasAccepted = Boolean(affiliateId) && record?.version === CURRENT_POLICY_VERSION;

  const acceptPolicy = useCallback(() => {
    if (!affiliateId) return;
    const newRecord: PolicyAcceptanceRecord = {
      version: CURRENT_POLICY_VERSION,
      acceptedAt: new Date().toISOString()
    };
    window.localStorage.setItem(storageKey(affiliateId), JSON.stringify(newRecord));
    setRecord(newRecord);
  }, [affiliateId]);

  return { hasAccepted, acceptPolicy, acceptedAt: record?.acceptedAt };
};
